import * as React from 'react';

const Parser = require('html-react-parser');

interface InfoBoxProps {
  heading: string;
  bodyText?: string | JSX.Element;
  linkText: string;
  children?: JSX.Element[];
}

const InfoBox = ({
  heading,
  bodyText,
  linkText,
  children,
}: InfoBoxProps) => (
  <div className="cell info-box">
    <div className="heading">{heading}</div>
    {children &&
      <div className="figures-box">
        {...children}
      </div>
    }
    {bodyText &&
      <div className="body-text">
        {typeof bodyText === 'string' && Parser(bodyText)}
        {typeof bodyText !== 'string' && bodyText}
      </div>
    }
    <div className="link-text">{Parser(linkText)}</div>
  </div>
);

export default InfoBox;



// WEBPACK FOOTER //
// ./src/components/InfoBox/InfoBox.tsx